import { useAuthUser } from '@projectK/hooks/AuthHooks';
import { Grid } from '@mui/material';
import ServiceDeskButton from '../../ServiceDeskWidget';
import { useEffect, useState } from 'react';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import VerticalNav from '../VerticalNav';
import PropTypes from 'prop-types';

const FooterCard = ({allUsers, filteredMenu, hasServiceDeskPermission}) => {
  const { user } = useAuthUser();
  const [isJSDLoaded, setIsJSDLoaded] = useState(false);
  useEffect(() => {
    const checkJSD = () => {
      let iframe = document.querySelector('#jsd-widget'); 
      if (iframe) {
        setIsJSDLoaded(true);
      } else {
        setTimeout(checkJSD, 500); 
      }
    };
    checkJSD();
  }, [isJSDLoaded]);

  

  return (
    <Grid className='MenuItem-sidebar' sx={{pb : 2}}>
    
    <VerticalNav routesConfig={filteredMenu} />
     
      
     {hasServiceDeskPermission && (
      <ServiceDeskButton
        isJSDLoaded={isJSDLoaded}
        isMobile={false}
        ListItemIcon={ListItemIcon}
        ListItemText={ListItemText}
      />
     )}
      {user?.id && (
        <VerticalNav routesConfig={allUsers()} />
      )}
    </Grid>
  );
};

export default FooterCard;
FooterCard.propTypes = {
  allUsers: PropTypes.func, // function returning list of users/menu
  filteredMenu: PropTypes.arrayOf(PropTypes.object), // array of menu items
  hasServiceDeskPermission: PropTypes.bool, // function checking permissions
};